var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 5.78V11.5C1 12.0304 1.21071 12.5391 1.58579 12.9142C1.96086 13.2893 2.46957 13.5 3 13.5H13C13.5304 13.5 14.0391 13.2893 14.4142 12.9142C14.7893 12.5391 15 12.0304 15 11.5V5.78L9.048 9.442C8.73283 9.6359 8.37004 9.73856 8 9.73856C7.62996 9.73856 7.26717 9.6359 6.952 9.442L1 5.78Z",
    fill: "#CDCED6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 4.60533V4.5C15 3.96957 14.7893 3.46086 14.4142 3.08579C14.0391 2.71071 13.5304 2.5 13 2.5H3C2.46957 2.5 1.96086 2.71071 1.58579 3.08579C1.21071 3.46086 1 3.96957 1 4.5V4.60533L7.476 8.59067C7.63359 8.68762 7.81498 8.73895 8 8.73895C8.18502 8.73895 8.36641 8.68762 8.524 8.59067L15 4.60533Z",
    fill: "#CDCED6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.60a159d0d81960b36b193bc98bacb16d.svg";
export { ForwardRef as ReactComponent };